import { SvgIcon, SvgIconProps } from '@mui/material';

const CheckCircleOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="CheckCircleOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M17.457 9.45703L10 16.9141L5.79297 12.707L7.20703 11.293L10 14.0859L16.043 8.04297L17.457 9.45703Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
      />
    </SvgIcon>
  );
};

export default CheckCircleOutlined;
